/**
 * Email Signup Block Component
 *
 * - Adjusts padding when an integrated text button has a variable width.
 * - Omits empty optional first_name on submit so Shopify still creates the
 *   contact from email alone (blank contact[first_name] can reject the post).
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input--email') || this.querySelector('input[type="email"]');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    this.form = this.querySelector('form');
    this.firstNameInput = this.querySelector('.email-signup__input--first-name');

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit);
    }

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.form) {
      this.form.removeEventListener('submit', this.handleSubmit);
    }
  }

  handleSubmit() {
    if (!this.firstNameInput) return;

    // Only send first_name when the customer actually entered one.
    if (!String(this.firstNameInput.value || '').trim()) {
      this.firstNameInput.disabled = true;
    } else {
      this.firstNameInput.disabled = false;
      this.firstNameInput.value = String(this.firstNameInput.value).trim();
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
